var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-bbox": "33.5 36 133 128",
    viewBox: "0 0 200 200",
    height: 200,
    width: 200,
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "color",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M165.345 49.488l-65.821 66.666c-.745.754-1.758 1.179-2.815 1.179s-2.069-.424-2.815-1.179l-19.747-20a4.022 4.022 0 0 1 .015-5.657 3.95 3.95 0 0 1 5.615.015l16.932 17.149 63.006-63.815a3.953 3.953 0 0 1 5.615-.015 4.022 4.022 0 0 1 .015 5.657zM155.948 96c-2.193 0-3.97 1.791-3.97 4v46.667c0 5.146-4.124 9.333-9.194 9.333h-92.15c-5.069 0-9.194-4.187-9.194-9.333V53.333c0-5.146 4.124-9.333 9.194-9.333h72.404c2.193 0 3.97-1.791 3.97-4s-1.778-4-3.97-4H50.634C41.186 36 33.5 43.775 33.5 53.333v93.334c0 9.558 7.686 17.333 17.134 17.333h92.15c9.448 0 17.134-7.775 17.134-17.333V100c0-2.209-1.778-4-3.97-4z",
    fill: "#000001",
    "data-color": 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.c7f68b66d6d8a9b9cae679980ff43778.svg";
export { ForwardRef as ReactComponent };